<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel name="تقرير حافظة ارفاقك صك" :stringifyLongNum="true" :fetch="fetchData" :fields="json_fields"
      :header="[
        name,
        desc,
        `تقرير حافظة ارفاق صك عن شهر ${convert_Month(month)}`,
      ]">
      <!-- :footer="footerArray" -->
      طباعة Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  mounted() {
    // this.getCompanyInfo();
  },
  props: ["month", "bankBranch", "date", "name", "desc" ,"FilterDeparmentClassificationsIds","bankClassificationId"],
  data() {
    return {
      json_fields: {
        "الرقم المالي": "financialNumber",
        "الرقم الوطنى": "nationalNumber",
        "إسم الموظف": "employeeName",
        "رقم الحساب": "accountNumber",
        "صافى المرتبات": "netSalary",
      },
      headerArray: [this.date],
      footerArray: ["تقرير حافظة ارفاق صك"],
    };
  },
  methods: {
    async getCompanyInfo() {
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let result = await axios.get(`${env.HR()}/api/companyinfos`, {
        headers: { Authorization: "Bearer " + token },
      });

      this.headerArray.unshift(result.data.data.shortName);
      this.headerArray.unshift(result.data.data.fullName);
    },
    async fetchData() {
      if (this.month == "1970-1-1") {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال شهر المرتب "
        );
      }
      if (!this.bankBranch) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال فرع البنك"
        );
      }

      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let schema = {
        MonthDate: this.month,
        BankBranchId: this.bankBranch,
        BankClassificationId: this.bankClassificationId,

        FilterDeparmentClassificationsIds: this.FilterDeparmentClassificationsIds == "" ? null : this.FilterDeparmentClassificationsIds,
      };
      let res = await axios.patch(
        `${env.HR()}/api/SalariesReports/SalariesChequePerBankBranch`,
        schema,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );
      return res.data.data.items;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) { }
    },
  },
};
</script>

<style lang="scss" scoped></style>